import React from 'react';
import ReviewProgressSummary from './ReviewProgressSummary';

import {auth} from '../../Security/firebase-config';
import useRecordingReviewProgress from './useRecordingReviewProgress';

import './TeamLibrary.css';

export async function notifyRecordingReady(teamId,mapId,videoId){
  if(!auth.currentUser)throw new Error('Sign in to notify your team.');
  const token=await auth.currentUser.getIdToken();
  const response=await fetch(`https://us-central1-${auth.app.options.projectId}.cloudfunctions.net/notifyVodReady`,{method:'POST',headers:{'Content-Type':'application/json',Authorization:'Bearer '+token},body:JSON.stringify({teamId,mapId,videoId})});
  if(!response.ok)throw new Error('The ready-for-review notification could not be sent. Check your team permissions and try again.');
  return response.json();
}
export default function RecordingReviewProgress({teamId,slot,viewerId,expanded=false,notify=true,enabled=true}){
  const cloudSlot={...slot,videos:slot.videos.filter(video=>!video.isLocal)};
  const model=useRecordingReviewProgress(teamId,cloudSlot,enabled);
  const ready=cloudSlot.videos.find(video=>video.status==='ready'||(!video.status&&(video.url||video.videoURL||video.videoUrl||video.storagePath||video.youtubeUrl||video.playbackMode==='segment_playlist')));
  if(!enabled||!cloudSlot.videos.length)return null;
  return <ReviewProgressSummary {...model} viewerId={viewerId} expanded={expanded} inline={expanded} onNotify={notify&&ready?async()=>{await notifyRecordingReady(teamId,slot.mapId,ready.id);}:undefined}/>;
}